<template>
    <div class="item-alert-message keep-format" :class="alertType">
        <div v-if="iconClass" :class="['item-alert-icon', 'i-andy-s', iconClass]"></div>
        <div v-if="isIncidence && incidenceLabel" class="incidence-prefix">{{ incidenceLabel }}</div>
        <div v-if="preview" class="preview-wrapper" :class="{ 'show-preview': !isIncidence }">
            <span class="preview" v-html="preview"></span>
        </div>
        <slot name="read-more"></slot>
    </div>
</template>

<script>
export default {
    name: 'AlertMessage',
    props: {
        type: {
            type: [String, Array],
            default: 'warning'
        },
        preview: {
            type: String,
            default: ''
        },
        isIncidence: {
            type: Boolean,
            default: false
        },
        incidenceLabel: {
            type: String,
            default: ''
        }
    },
    computed: {
        alertType() {
            const raw = Array.isArray(this.type) ? this.type[0] : this.type
            const normalized = (raw && String(raw).toLowerCase()) || 'warning'
            if (['warning', 'error', 'info'].includes(normalized)) {
                return normalized
            }
            return 'warning'
        },
        iconClass() {
            const map = {
                warning: 'i-andy-menu-task',
                error: 'i-andy-exclamation',
                info: 'i-andy-info-main'
            }
            return map[this.alertType] || map.warning
        }
    }
}
</script>

<style lang="scss" scoped>
.item-alert-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
    flex: 1;
}

.i-andy-menu-task {
    color: #cc9f00;
}

.i-andy-exclamation {
    color: #bd1f1e;
}

.i-andy-info-main {
    color: #2c52c4;
}

.item-alert-icon {
    flex-shrink: 0;
    padding-left: 8px;
}

.incidence-prefix {
    font-weight: bold;
    flex-shrink: 0;
}

.preview-wrapper {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.preview-wrapper.show-preview {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
}

.preview-wrapper .preview {
    display: inline;
}
</style>
